import React from 'react';

function Twitter() {
  return (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76.50571 76.50571">
      <title>Twitter</title>
      <path d="M38.25285,0A38.25285,38.25285,0,1,0,76.50571,38.25285,38.252,38.252,0,0,0,38.25285,0Zm0,71.56932A33.31646,33.31646,0,1,1,71.56932,38.25285,33.31581,33.31581,0,0,1,38.25285,71.56932Z" fill="#bdbebf" />
      <path d="M21.18566,52.019a21.87163,21.87163,0,0,0,11.84474,3.47224c14.34644,0,22.45141-12.11766,21.96332-22.98632a15.664,15.664,0,0,0,3.85555-4.0001,15.44072,15.44072,0,0,1-4.43757,1.21642,7.73986,7.73986,0,0,0,3.39643-4.27478,15.488,15.488,0,0,1-4.90566,1.87618A7.73228,7.73228,0,0,0,39.7346,34.3703a21.92933,21.92933,0,0,1-15.9262-8.07424,7.73632,7.73632,0,0,0,2.39138,10.31737,7.69791,7.69791,0,0,1-3.50119-.967,7.73579,7.73579,0,0,0,6.198,7.67482,7.7325,7.7325,0,0,1-3.48851.13188,7.73145,7.73145,0,0,0,7.21746,5.36662A15.52949,15.52949,0,0,1,21.18566,52.019Z" fill="#bdbebf" />
    </svg>
  );
}

export default Twitter;



// WEBPACK FOOTER //
// ./client/components/shared/SocialMediaLinks/icons/Twitter.js